module.exports = __webpack_public_path__ + "img/美丽部落.f15a0ad.png";